export default {
  hero: {
    title: 'Liên Hệ Với Chúng Tôi',
    subtitle: 'Chúng tôi luôn sẵn sàng lắng nghe và hỗ trợ bạn',
  },
  info: {
    title: 'Thông Tin Liên Hệ',
    description: 'Hãy liên hệ với chúng tôi qua các kênh dưới đây hoặc điền vào form bên cạnh. Đội ngũ chuyên viên sẽ phản hồi trong vòng 24 giờ.',
    address: {
      label: 'Địa Chỉ',
      value: 'Krisjana Barona Iela 96/98, Riga, Latvia',
      line2: 'Chúng tôi không có văn phòng tại Việt Nam',
    },
    phone: {
      label: 'Điện Thoại',
      value: '+371 2572 6969',
      display: 'Latvia: +371 2572 6969 (Call / Whatsapp / Viber)',
    },
    email: {
      label: 'Email',
      value: 'contact@thedaeg.com',
    },
    hours: {
      label: 'Giờ Làm Việc',
      value: 'Thứ 2 - Thứ 6: 9:00 - 18:00',
      saturday: 'Thứ 7: 9:00 - 12:00',
    },
  },
  social: {
    title: 'Theo Dõi Chúng Tôi',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
  },
  form: {
    title: 'Gửi Tin Nhắn Cho Chúng Tôi',
    description: 'Điền thông tin dưới đây và chúng tôi sẽ phản hồi trong vòng 24 giờ.',
    labels: {
      fullName: 'Họ và Tên',
      phone: 'Số Điện Thoại',
      email: 'Email',
      subject: 'Chủ Đề',
      message: 'Nội Dung',
    },
    placeholders: {
      fullName: 'Nhập họ và tên',
      phone: 'Số điện thoại',
      email: 'Email',
      subject: 'Bạn cần hỗ trợ về vấn đề gì?',
      message: 'Mô tả chi tiết câu hỏi của bạn... (tối đa 500 ký tự)',
    },
    required: 'Bắt buộc',
    submit: 'Gửi Tin Nhắn',
    submitting: 'Đang gửi...',
    success: 'Gửi tin nhắn thành công! Chúng tôi sẽ liên hệ với bạn sớm nhất.',
    error: 'Có lỗi xảy ra. Vui lòng thử lại sau.',
    charCount: 'ký tự',
  },
  breadcrumb: {
    home: 'Trang Chủ',
    contact: 'Liên Hệ',
  },
} as const;
